import { Choice } from './Choice';
export class Cleavage {
    constructor(cleavageDto) {
        this.title = cleavageDto.title;
        this.leftChoice = new Choice(cleavageDto.leftChoice);
        this.rightChoice = new Choice(cleavageDto.rightChoice);
        this.players = cleavageDto.players;
    }
    majorScore() {
        const majorChoice = this.majorChoice();
        const totalCleave = this.leftChoice.players.length + this.rightChoice.players.length;
        return majorChoice
            ? majorChoice === this.leftChoice.name
                ? this.leftChoice.players.length / totalCleave * 100
                : this.rightChoice.players.length / totalCleave * 100
            : 50;
    }
    majorChoice() {
        return this.leftChoice.players.length > this.rightChoice.players.length
            ? this.leftChoice.name
            : this.leftChoice.players.length < this.rightChoice.players.length
                ? this.rightChoice.name
                : undefined;
    }
    toDto() {
        return {
            title: this.title,
            leftChoice: this.leftChoice.toDTO(),
            rightChoice: this.rightChoice.toDTO(),
            players: this.players
        };
    }
}
